import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import * as actionTypes from '../../../redux-store/redux-actions/redux-actions';

class Logout extends Component{

    componentDidMount(){
        this.props.logout();
    }

    render(){
        return <Redirect to="/login"/>;
    }
}

const mapDispatchtoProps = dispatch => {
    return {
        logout : () => dispatch(actionTypes.logout())
    }
}

export default connect(null,mapDispatchtoProps)(Logout);